<div class="body" [ngClass]="getBodyClass()">
  <ul class="nav nav-tabs">
    <li class="nav-item" *ngFor="let tab of dynamicTabService.tabs">
      <a class="nav-link" (click)="openTab(tab)" [class.active]="tab.isActive">{{tab.label}}</a>
      <button class="close-tab" (click)="closeTab(tab)">x</button>
    </li>

  </ul>
  <div class="tab-content">
    <div class="tab-pane fade " *ngFor="let tab of dynamicTabService.tabs" [class.show]="tab.isActive"
      [class.active]="tab.isActive">
<!--       
      <app-main [label]="'Home'" *ngIf="tab.label=='Home'"></app-main> -->
     
      <app-associations *ngIf="tab.label=='Associations'"
       (openDetailTab)="openDetailTab($event)"></app-associations>

      <app-association-addnew [label]=currentTabName *ngIf="tab.routerLink=='AssnAddNew'"
        (openDetailTab)="openDetailTab($event)"></app-association-addnew>

      <app-masterpolicies *ngIf="tab.label=='Master Policies'"
        (openDetailTab)="openDetailTab($event)"></app-masterpolicies>

      <app-premiumtransactions *ngIf="tab.label=='Premium Transactions'"
        (openDetailTab)="openDetailTab($event)"></app-premiumtransactions>

      <app-policy-addnew [label]=currentTabName *ngIf="tab.routerLink=='policyAddNew'"
      (openDetailTab)="openDetailTab($event)"></app-policy-addnew>
      
      <app-guides *ngIf="tab.label=='Abandoned Apps'"></app-guides>
      
      <app-association-details [id]=currentTabId [label]=currentTabName [type]=currentTabType
        [class.hidden]="tab.label !==currentTabName || tab.type !== 'association'" 
        (openDetailTab)="openDetailTab($event)"></app-association-details>
     
        <app-main [id]=currentTabId [label]=currentTabName [type]=currentTabType 
         [class.hidden]="tab.label !==currentTabName || tab.type !== 'policy'"
        (openDetailTab)="openDetailTab($event)"></app-main>
         

       <hr/>
    </div>
  </div>
</div>